import { useEffect, useState } from "react";
import { Download, FileDown, Printer } from "lucide-react";
import { api, API } from "@/lib/api";
import { PageHeader } from "@/components/admin/AdminLayout";
import { Button } from "@/components/ui/button";

export default function Docs() {
  const [html, setHtml] = useState("");
  useEffect(() => { api.get("/admin/docs").then((r) => setHtml(r.data.html)); }, []);
  return (
    <div className="fade-up max-w-4xl">
      <div className="print:hidden">
        <PageHeader title="Documentazione" sub="Guida completa da inviare al tuo sviluppatore">
          <a href={`${API}/admin/docs.pdf`} data-testid="docs-download-pdf"><Button className="bg-emerald-900 hover:bg-emerald-800"><FileDown size={16} /> Scarica PDF</Button></a>
          <a href={`${API}/admin/plugin.zip`} data-testid="docs-download-plugin"><Button variant="outline"><Download size={16} /> Plugin WordPress</Button></a>
          <Button variant="outline" onClick={() => window.print()} data-testid="docs-print-button"><Printer size={16} /> Stampa</Button>
        </PageHeader>
      </div>
      <article className="docs-content bg-white border border-gray-200 rounded-lg p-6 sm:p-10" data-testid="docs-content" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
